import { metric } from '../api';
import { L, config, state } from '../state';
import { escapeHtml, hideModal, need, show } from '../ui/modal';

/** El aviso de IA nombra al operador configurado, no a Talkxi. */
function notice() {
  const source = L().notice;
  const operator = config.tenantName && config.tenantName !== 'Talkxi'
    ? config.tenantName
    : 'la empresa operadora';
  const out = { ...source } as Record<string, string>;
  for (const key of Object.keys(out)) {
    out[key] = String(out[key]).replaceAll('{{OPERATOR}}', operator);
  }
  return out as unknown as typeof source;
}

export function showPrivacy(): void {
  const n = notice();
  void metric('privacy_open');
  show(n.privacyTitle, `
    <div class="privacy-box">
      <p>${escapeHtml(n.privacyBody)}</p>
      <p><a class="mini privacy-link" href="${escapeHtml(config.privacyUrl || './privacidad-ai.html')}"
            target="_blank" rel="noopener noreferrer">${escapeHtml(n.generalPolicy)}</a></p>
      <button id="privacyBack" class="cta" type="button">${escapeHtml(n.back)}</button>
    </div>`);
  need('#privacyBack').onclick = () => showAINotice();
}

export function showAINotice(next: (() => void) | null = null): void {
  if (next) state.pendingAfterNotice = next;
  const n = notice();
  show(n.title, `
    <div class="ai-notice">
      <p class="notice-lead">🤖 ${escapeHtml(n.lead)}</p>
      <ul>
        <li>${escapeHtml(n.ai)}</li>
        <li>${escapeHtml(n.mic)}</li>
        <li>${escapeHtml(n.metrics)}</li>
        <li>${escapeHtml(n.session)}</li>
      </ul>
      <div class="notice-actions">
        <button id="noticeContinue" class="cta" type="button">${escapeHtml(n.continue)}</button>
        <button id="noticePrivacy" class="mini" type="button">${escapeHtml(n.privacy)}</button>
      </div>
    </div>`);

  need('#noticePrivacy').onclick = showPrivacy;
  need('#noticeContinue').onclick = () => {
    state.aiNoticeSeen = true;
    void metric('notice_continue');
    if (!state.sessionTracked) {
      state.sessionTracked = true;
      void metric('session_started');
    }
    const callback = state.pendingAfterNotice;
    state.pendingAfterNotice = null;
    if (callback) callback();
    else hideModal();
  };
}

/** Ejecuta `fn` sólo después de que el pasajero acepte el aviso de IA. */
export function withAINotice(fn: () => void): void {
  if (state.aiNoticeSeen) fn();
  else showAINotice(fn);
}
